const STATUS_MESSAGES = {
  400: 'Parâmetros inválidos na requisição.',
  401: 'Sessão expirada. Entre novamente.',
  403: 'Você não tem permissão para esta ação.',
  404: 'Registro não encontrado.',
  409: 'Conflito com um registro existente.',
  413: 'Arquivo excede o tamanho máximo permitido.',
  415: 'Tipo de arquivo não permitido.',
  422: 'Dados inválidos para esta operação.'
};

export function serverMessage(response) {
  const data = (response && response.data) || {};
  if (Array.isArray(data.message)) return data.message.join(' ');
  return typeof data.message === 'string' ? data.message : '';
}

export function httpErrorMessage(response, fallback = 'Falha ao comunicar com o servidor.') {
  const status = response && response.status;
  const detail = serverMessage(response);
  if (STATUS_MESSAGES[status])
    return detail ? `${STATUS_MESSAGES[status]} ${detail}` : STATUS_MESSAGES[status];
  return detail || fallback;
}

export function httpFailure(response, fallback) {
  const status = response && response.status;
  const data = (response && response.data) || {};
  return {
    status,
    code: status ? `HTTP_${status}` : 'HTTP_ERROR',
    reason: typeof data.error === 'string' ? data.error : null,
    detail: serverMessage(response),
    message: httpErrorMessage(response, fallback)
  };
}

export function rejectWithFailure($q, fallback) {
  return (response) => $q.reject(httpFailure(response, fallback));
}

export function requestData($q, request, fallback, map) {
  return request.then((response) => map(response.data), rejectWithFailure($q, fallback));
}

export default httpErrorMessage;
